import React, { Component } from "react";
import { Nav } from "reactstrap";
import PropTypes from "prop-types";

import { AppNavbarBrand, AppSidebarToggler } from "@coreui/react";
import DefaultHeaderDropdown from "./DefaultHeaderDropdown";
import logo from "../../assets/img/brand/Logo.png";

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultHeader extends Component {
  render() {
    const { data } = this.props;
    if (!localStorage.getItem("token")) {
      this.props.history.push(`/login`);
    }
    if (data.loading) return <div />;
    const user = data.me;
    const role = user.role;
    let dashboarURL = "/dashboard";
    if (role === "TEACHER") {
      dashboarURL = user.schools[0] ? "/school/" + user.schools[0]?.id : "/dashboard";
    } else if (role === "COORDINATOR") {
      dashboarURL = user.schoolsAdmin[0] ? "/school/" + user.schoolsAdmin[0]?.id : "/dashboard";
    } else if (role === "STUDENT" || role === "PARENT") {
      dashboarURL = "/student/" + user.id;
    }

    return (
      <React.Fragment>
        {(role === "ADMIN" || role === "SUPERADMIN" || role === "EVALUATOR") && <AppSidebarToggler className="mb-2" display="md" mobile />}
        <AppNavbarBrand full={{ src: logo, width: 110, height: 37, alt: "SERA Logo" }} minimized={{ src: logo, width: 30, height: 30, alt: "SERA Logo" }} href={dashboarURL} />
        <Nav className="ml-auto" navbar>
          <DefaultHeaderDropdown accnt notif history={this.props.history} />
          <DefaultHeaderDropdown accnt history={this.props.history} />
        </Nav>
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

export default DefaultHeader;
